import { render, staticRenderFns } from "./ResultOverall.vue?vue&type=template&id=0e37996a&"
import script from "./ResultOverall.vue?vue&type=script&lang=js&"
export * from "./ResultOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports